import { Link } from 'react-router-dom';
import type { Manhwa } from '@/types';

interface FeaturedManhwaProps {
  manhwaList: Manhwa[];
}

export default function FeaturedManhwa({ manhwaList }: FeaturedManhwaProps) {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              编辑精选，不容错过的韩漫佳作
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {manhwaList.map((manhwa) => (
            <Link
              key={manhwa.id}
              to={`/article/${manhwa.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
                <img
                  src={manhwa.cover}
                  alt={manhwa.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={manhwa.title}
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${
                    manhwa.status === '连载中'
                      ? 'bg-primary-500 text-white'
                      : 'bg-foreground-600 text-white'
                  }`}>
                    {manhwa.status}
                  </span>
                </div>
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1 text-accent-500 text-xs">
                    <i className="ri-star-fill"></i>
                    <span className="text-white font-semibold">{manhwa.rating}</span>
                    <span className="text-white/60 ml-2">{manhwa.views}阅读</span>
                  </div>
                </div>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                {manhwa.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">{manhwa.author}</p>
            </Link>
          ))}
        </div>

        <div className="sm:hidden mt-6 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}